import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/home.css';

const HomePage = () => {
  return (
    <div className="home-root">
      <section className="home-hero">
        <div className="home-hero-inner">
          <div className="home-hero-copy">
            <h1 className="home-hero-title">
              Programas y Talleres que{' '}
              <span className="home-hero-highlight">Transforman Vidas</span>
            </h1>
            <p className="home-hero-subtitle">
              Buscamos construir un entorno inclusivo y comprensivo que valore y celebre la diversidad en todas sus
              formas.
            </p>
            <div className="home-hero-actions">
              <Link to="/about" className="home-hero-cta">
                Conoce más acerca de nosotros &gt;
              </Link>
            </div>
          </div>
          <div className="home-hero-visual">
            <img
              src={`${process.env.PUBLIC_URL}/images/hero-ninos.png`}
              alt="Niños abrazándose"
              className="home-hero-photo"
            />
          </div>
        </div>
      </section>

      <section className="home-sponsors">
        <div className="home-sponsors-inner">
          <img
            src={`${process.env.PUBLIC_URL}/images/logos-empresas.png`}
            alt="Logos de empresas patrocinadoras"
            className="home-sponsors-banner"
          />
        </div>
      </section>

      <section className="home-section home-section-purpose">
        <div className="home-section-inner home-purpose-inner">
          <div className="home-purpose-copy">
            <h2 className="home-section-title">Nuestro Propósito</h2>
            <p className="home-purpose-subtitle">Pasión y compromiso a brindar terapias especializadas</p>
            <p className="home-section-text">
              En nuestra fundación, nos dedicamos a dar apoyo integral a niños con diagnósticos diversos y neuro
              divergencias, como el autismo, TDAH, trastornos del aprendizaje y otras condiciones del
              neurodesarrollo. Nuestra misión es promover su bienestar emocional, cognitivo y social, fortaleciendo sus
              habilidades y acompañándolos en cada etapa de su crecimiento.
            </p>
            <p className="home-section-text">
              Creemos en un enfoque personalizado y multidisciplinario, donde cada niño recibe las herramientas y
              estrategias necesarias para desenvolverse con confianza en su entorno. Trabajamos en colaboración con
              familias, educadores y profesionales de la salud para crear redes de apoyo que fomenten su desarrollo
              pleno.
            </p>
            <Link to="/volunteer" className="home-purpose-cta">
              Quiero formar parte &gt;
            </Link>
          </div>

          <div className="home-purpose-visual">
            <img
              src={`${process.env.PUBLIC_URL}/images/nuestro-proposito.png`}
              alt="Galería de nuestro propósito"
              className="home-purpose-collage"
            />
          </div>
        </div>
      </section>

      <section className="home-section home-section-interest">
        <div className="home-section-inner">
          <h2 className="home-section-title home-interest-title">Te Podría Interesar</h2>

          <div className="home-interest-grid">
            <article className="home-interest-card home-interest-card-premium">
              <div className="home-interest-card-copy">
                <h3 className="home-interest-card-title">
                  ¡Actualiza Tu Plan Ahora!
                  <span className="home-interest-badge">★ Premium</span>
                </h3>
                <p className="home-interest-card-text">
                  ¡Descubre todos los beneficios a un bajo costo!
                </p>
                <Link to="/subscriptions" className="home-interest-btn home-interest-btn-cyan">
                  Ver planes
                </Link>
              </div>
              <img
                src={`${process.env.PUBLIC_URL}/images/interest-boy.png`}
                alt="Niño sonriendo"
                className="home-interest-card-photo"
              />
            </article>

            <article className="home-interest-card home-interest-card-therapies">
              <div className="home-interest-card-copy">
                <h3 className="home-interest-card-title">Terapias y Actividades Increíbles</h3>
                <p className="home-interest-card-text">
                  Buscamos construir un entorno inclusivo y comprensivo que valore y celebre la diversidad en todas sus
                  formas.
                </p>
                <Link to="/services" className="home-interest-btn home-interest-btn-blue">
                  Ver servicios
                </Link>
              </div>
              <img
                src={`${process.env.PUBLIC_URL}/images/interest-girl.png`}
                alt="Niña sonriendo"
                className="home-interest-card-photo"
              />
            </article>
          </div>
        </div>
      </section>

      <section className="home-section home-section-services">
        <div className="home-section-inner">
          <div className="home-services-header">
            <h2 className="home-section-title home-services-title">Servicios que Ofrecemos</h2>
            <p className="home-services-subtitle">
              Trabajamos con pasión y compromiso para marcar una diferencia en sus vidas
            </p>
            <p className="home-services-vision">
              Nuestra visión es un mundo donde todos los niños, independientemente de sus diagnósticos o
              neurodivergencias, tengan la oportunidad de alcanzar su máximo potencial.
            </p>
          </div>

          <div className="home-services-grid">
            <article className="home-service-card home-service-card-therapies">
              <div className="home-service-card-visual">
                <img
                  src={`${process.env.PUBLIC_URL}/images/service-terapias.png`}
                  alt=""
                  className="home-service-card-photo"
                  aria-hidden="true"
                />
              </div>
              <div className="home-service-card-body home-service-card-body-blue">
                <h3 className="home-service-card-title">Terapias</h3>
                <p className="home-service-card-text">
                  Buscamos construir un entorno inclusivo y comprensivo que valore y celebre la diversidad en todas sus
                  formas.
                </p>
                <Link to="/services" className="home-service-btn home-service-btn-cyan">
                  Ver terapias disponibles
                </Link>
              </div>
            </article>

            <article className="home-service-card home-service-card-evaluations">
              <div className="home-service-card-body home-service-card-body-dark">
                <h3 className="home-service-card-title">Evaluaciones</h3>
                <p className="home-service-card-text">
                  En nuestro centro, realizamos evaluaciones especializadas (como TEA, TDAH, dislexia u otras
                  diferencias en el desarrollo).
                </p>
                <Link to="/services" className="home-service-btn home-service-btn-magenta">
                  Agenda una evaluación &gt;
                </Link>
              </div>
            </article>

            <article className="home-service-card home-service-card-extracurricular">
              <div className="home-service-card-visual">
                <img
                  src={`${process.env.PUBLIC_URL}/images/service-extracurriculares.png`}
                  alt=""
                  className="home-service-card-photo"
                  aria-hidden="true"
                />
              </div>
              <div className="home-service-card-body home-service-card-body-magenta">
                <h3 className="home-service-card-title">Extracurriculares</h3>
                <p className="home-service-card-text">
                  Realizamos talleres lúdicos y educativos, donde aprenden, crecen y se divierten en un espacio
                  inclusivo.
                </p>
                <Link to="/services" className="home-service-btn home-service-btn-blue">
                  Ver talleres disponibles
                </Link>
              </div>
            </article>
          </div>
        </div>
      </section>

      <section className="home-section home-section-volunteer">
        <div className="home-section-inner home-volunteer-inner">
          <div className="home-volunteer-copy">
            <h2 className="home-section-title home-volunteer-title">Comunidad de Voluntariados</h2>
            <p className="home-volunteer-highlight">¡Somos más de 60 voluntariados!</p>
            <p className="home-volunteer-text">
              Sé parte del cambio que el mundo necesita. Juntos podemos transformar vidas, apoyar causas importantes y
              construir un futuro más solidario.
            </p>
            <Link to="/volunteer" className="home-volunteer-btn">
              Llenar formulario &gt;
            </Link>
          </div>

          <div className="home-volunteer-collage">
            <img
              src={`${process.env.PUBLIC_URL}/images/volunteer-boy-book.png`}
              alt="Voluntario leyendo con un niño"
              className="home-volunteer-photo home-volunteer-photo-boy"
            />
            <div className="home-volunteer-speech">
              <span className="home-volunteer-speech-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" />
                </svg>
              </span>
              <Link to="/blog" className="home-volunteer-speech-link">
                ¡No te pierdas nuestras próximas charlas y talleres!
              </Link>
            </div>
            <img
              src={`${process.env.PUBLIC_URL}/images/volunteer-tutor-girl.png`}
              alt="Voluntaria apoyando a una niña"
              className="home-volunteer-photo home-volunteer-photo-tutor"
            />
            <img
              src={`${process.env.PUBLIC_URL}/images/volunteer-hands.png`}
              alt="Manos unidas en equipo"
              className="home-volunteer-photo home-volunteer-photo-hands"
            />
            <img
              src={`${process.env.PUBLIC_URL}/images/volunteer-tablet.png`}
              alt="Voluntario ayudando a un niño"
              className="home-volunteer-photo home-volunteer-photo-tablet"
            />
            <img
              src={`${process.env.PUBLIC_URL}/images/volunteer-team.png`}
              alt="Especialistas del equipo"
              className="home-volunteer-photo home-volunteer-photo-team"
            />
          </div>
        </div>
      </section>

      <section className="home-section home-section-agenda">
        <div className="home-section-inner">
          <div className="home-agenda-header">
            <h2 className="home-section-title home-agenda-title">Agenda con Nosotros</h2>
            <Link to="/services" className="home-agenda-more">
              Ver más &gt;
            </Link>
          </div>

          <article className="home-agenda-banner">
            <div className="home-agenda-banner-main">
              <img
                src={`${process.env.PUBLIC_URL}/images/agenda-banner-bg.png`}
                alt=""
                className="home-agenda-banner-photo"
                aria-hidden="true"
              />
              <div className="home-agenda-banner-overlay" />
              <div className="home-agenda-banner-copy">
                <div className="home-agenda-date">
                  <span className="home-agenda-date-day">08</span>
                  <span className="home-agenda-date-month">NOV</span>
                </div>
                <div className="home-agenda-banner-text">
                  <h3 className="home-agenda-banner-title">Agenda tu cita: Para una evaluación</h3>
                  <p className="home-agenda-banner-desc">
                    Reserva tu espacio para una evaluación especializada y recibe orientación personalizada para el
                    desarrollo de tu hijo.
                  </p>
                  <Link to="/services" className="home-agenda-banner-btn">
                    Más información &gt;
                  </Link>
                </div>
              </div>
            </div>

            <div className="home-agenda-calendar">
              <h4 className="home-agenda-calendar-title">Calendario de Citas</h4>
              <div className="home-agenda-calendar-nav">
                <button type="button" className="home-agenda-calendar-arrow" aria-label="Mes anterior">
                  &lt;
                </button>
                <span>Agosto 2025</span>
                <button type="button" className="home-agenda-calendar-arrow" aria-label="Mes siguiente">
                  &gt;
                </button>
              </div>
              <div className="home-agenda-calendar-weekdays">
                <span>Lun</span>
                <span>Mar</span>
                <span>Mié</span>
                <span>Jue</span>
                <span>Vie</span>
                <span>Sáb</span>
                <span>Dom</span>
              </div>
              <div className="home-agenda-calendar-days">
                <span />
                <span />
                <span />
                <span />
                <span>1</span>
                <span>2</span>
                <span>3</span>
                <span>4</span>
                <span>5</span>
                <span>6</span>
                <span>7</span>
                <span className="home-agenda-day-active">8</span>
                <span className="home-agenda-day-dot">9</span>
                <span>10</span>
                <span className="home-agenda-day-dot">11</span>
                <span>12</span>
                <span>13</span>
                <span className="home-agenda-day-dot">14</span>
                <span>15</span>
                <span>16</span>
                <span>17</span>
                <span className="home-agenda-day-dot">18</span>
                <span>19</span>
                <span>20</span>
                <span>21</span>
                <span>22</span>
                <span>23</span>
                <span>24</span>
                <span>25</span>
                <span>26</span>
                <span>27</span>
                <span>28</span>
                <span>29</span>
                <span>30</span>
                <span>31</span>
              </div>
            </div>
          </article>
        </div>
      </section>

      <section className="home-section home-section-courses">
        <div className="home-section-inner">
          <div className="home-courses-header">
            <h2 className="home-section-title home-courses-title">Nuestros Cursos Online</h2>
            <Link to="/services" className="home-courses-more">
              Ver más &gt;
            </Link>
          </div>

          <div className="home-courses-grid">
            <article className="home-course-card">
              <img
                src={`${process.env.PUBLIC_URL}/images/course-sensorial.png`}
                alt=""
                className="home-course-card-photo"
                width="894"
                height="570"
                decoding="async"
                aria-hidden="true"
              />
              <div className="home-course-card-overlay" aria-hidden="true" />
              <div className="home-course-card-content">
                <h3 className="home-course-card-title">Fundamentos de la Integración Sensorial</h3>
                <div className="home-course-card-footer">
                  <p className="home-course-label">
                    Capacitación <strong>Online</strong>
                  </p>
                  <Link to="/services" className="home-course-btn">
                    Ver curso &gt;
                  </Link>
                </div>
              </div>
            </article>

            <article className="home-course-card">
              <img
                src={`${process.env.PUBLIC_URL}/images/course-alimentacion.png`}
                alt=""
                className="home-course-card-photo"
                width="894"
                height="570"
                decoding="async"
                aria-hidden="true"
              />
              <div className="home-course-card-overlay" aria-hidden="true" />
              <div className="home-course-card-content">
                <h3 className="home-course-card-title">
                  Estrategias para Abordar la Alimentación desde la integración Sensorial
                </h3>
                <div className="home-course-card-footer">
                  <p className="home-course-label">
                    Capacitación <strong>Online</strong>
                  </p>
                  <Link to="/services" className="home-course-btn">
                    Ver curso &gt;
                  </Link>
                </div>
              </div>
            </article>

            <article className="home-course-card">
              <img
                src={`${process.env.PUBLIC_URL}/images/course-autismo.png`}
                alt=""
                className="home-course-card-photo"
                width="894"
                height="570"
                decoding="async"
                aria-hidden="true"
              />
              <div className="home-course-card-overlay" aria-hidden="true" />
              <div className="home-course-card-content">
                <h3 className="home-course-card-title">Abordar la Conducta en el Autismo</h3>
                <div className="home-course-card-footer">
                  <p className="home-course-label">
                    Capacitación <strong>Online</strong>
                  </p>
                  <Link to="/services" className="home-course-btn">
                    Ver curso &gt;
                  </Link>
                </div>
              </div>
            </article>
          </div>
        </div>
      </section>

      <section className="home-section home-section-therapies">
        <div className="home-section-inner">
          <h2 className="home-section-title home-therapies-title">Terapias Online</h2>

          <article className="home-therapies-banner">
            <img
              src={`${process.env.PUBLIC_URL}/images/logo-therappy.png`}
              alt="TherAppy+"
              className="home-therapies-logo"
            />
            <div className="home-therapies-copy">
              <h3 className="home-therapies-heading">Descarga TherAppy+</h3>
              <p className="home-therapies-text">Descripción de la página web</p>
              <div className="home-therapies-stores">
                <a
                  href="https://play.google.com/store"
                  className="home-store-badge home-store-badge-google"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="home-store-badge-small">GET IT ON</span>
                  <span className="home-store-badge-large">Google Play</span>
                </a>
                <a
                  href="https://www.apple.com/app-store/"
                  className="home-store-badge home-store-badge-apple"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="home-store-badge-small">Download on the</span>
                  <span className="home-store-badge-large">App Store</span>
                </a>
              </div>
            </div>
          </article>
        </div>
      </section>

      <section className="home-section home-section-donation">
        <div className="home-donation-banner-wrap">
          <img
            src={`${process.env.PUBLIC_URL}/images/donation-children-bg.png`}
            alt=""
            className="home-donation-bg"
            aria-hidden="true"
          />
          <div className="home-donation-overlay" aria-hidden="true" />

          <div className="home-donation-content">
            <svg
              className="home-donation-icon"
              viewBox="0 0 80 80"
              aria-hidden="true"
              focusable="false"
            >
              <path
                d="M40 9 C22 11 11 27 13 40 C15 53 27 59 40 54"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.6"
                strokeLinecap="round"
              />
              <path
                d="M40 71 C58 69 69 53 67 40 C65 27 53 21 40 26"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.6"
                strokeLinecap="round"
              />
              <path
                d="M27 37 C29 43 33 45 40 45"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M53 43 C51 37 47 35 40 35"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>

            <p className="home-donation-text">
              Dona hoy y ayuda a crear espacios inclusivos donde cada niño pueda brillar.
            </p>

            <Link to="/donations" className="home-donation-btn">
              Más información &gt;
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;

